import templateUrl from './report-progress.component.html';
import { JobStatus } from '../../core/enum/job-status';
import { ReportJobVM } from '../../core/services/data-services/report-job.service';
import { EventEmitter } from '../../common/components/event-emitter';

export const ReportProgressComponent = {
    bindings: {
        job: "<",
        cancel: "&onCancel"
    },
    templateUrl,
    controller: class ReportProgressComponent {
        job: ReportJobVM;
        JobStatus = JobStatus;
        cancel: EventEmitter<{job: ReportJobVM}>;
        constructor() {
            'ngInject';
        }

        onCancel() {
            this.cancel({
                $event: {
                    job: this.job
                }
            });
        }

        textClass(job: ReportJobVM) {
            switch (job.JobStatus) {
                case this.JobStatus.Succeeded:
                    return "text-success";
                case this.JobStatus.Failed:
                    return "text-danger";
                default:
                    return "";
            }
        }

        labelClass(job: ReportJobVM) {
            switch (job.JobStatus) {
                case this.JobStatus.Processing:
                    return "label-info";
                case this.JobStatus.Succeeded:
                    return "label-success";
                case this.JobStatus.Failed:
                    return "label-danger";
                case this.JobStatus.Queued:
                default:
                    return "label-default";
            }
        }

        progressClass(job: ReportJobVM) {
            switch (job.JobStatus) {
                case this.JobStatus.Processing:
                    return "";
                case this.JobStatus.Succeeded:
                    return "bg-success";
                case this.JobStatus.Failed:
                    return "bg-danger";
                case this.JobStatus.Queued:
                default:
                    return "";
            }
        }
    }
}
